'use strict';
import 'reflect-metadata';
import './polyfills';
import './vendor';

import * as angular from 'angular';

import { enableProdMode, PlatformRef, StaticProvider } from '@angular/core';
import { downgradeModule } from '@angular/upgrade/static';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { appModuleAngularJS } from '../noc/noc';

import { UrlService, UIRouter } from '@uirouter/core';

import * as Sentry from '@sentry/angular-ivy';


if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://dd84e32a095a6069e7858ec1247bf5e9@o4505963070947328.ingest.us.sentry.io/4507270904348672",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration()
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const bootstrapFn = (extraProviders: StaticProvider[]) => {
  const platformRef: PlatformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AppModule);
}
  

appModuleAngularJS.config(['$urlServiceProvider', ($urlService: UrlService) => $urlService.deferIntercept()]);

angular.bootstrap(document.body, [
  appModuleAngularJS.name, 
  downgradeModule(bootstrapFn)
  ]) ;

  const injector: angular.auto.IInjectorService = angular.element(document.body).injector();

  const urlService: UrlService = injector.get('$urlService');
  
  setTimeout(() => {
      // setTimeout needed to allow angular routes to initialize after refresh
      urlService.listen();
      urlService.sync();
  });
